"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2251],{

/***/ 33064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ LoadingText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26447);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);





var Fade = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)({
    from: {
        opacity: 0
    }
});
var FadingTypography = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
    var order = param.order;
    return {
        animation: "".concat(Fade, " 0.5s infinite alternate"),
        animationDelay: "".concat(-order * 0.8, "s")
    };
});
var LoadingText = function(param) {
    var symbol = param.symbol, repeatSymbol = param.repeatSymbol, variant = param.variant, _spacing = param.spacing, spacing = _spacing === void 0 ? 0.25 : _spacing, _size = param.size, size = _size === void 0 ? 14 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        direction: "row",
        spacing: spacing,
        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(Array(repeatSymbol)).map(function(_s, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FadingTypography, {
                fontSize: size,
                variant: variant !== null && variant !== void 0 ? variant : "body2",
                order: index + 1,
                children: lodash__WEBPACK_IMPORTED_MODULE_2___default().isArray(symbol) ? symbol.length - 1 > index ? symbol[index] : null : symbol
            }, index);
        })
    });
};


/***/ }),

/***/ 84613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ TOKEN_BUY_LINKS; }
/* harmony export */ });
/* unused harmony export CURVE_VST_POOL_LINK */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _config_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87859);


var CURVE_VST_POOL_LINK = "https://arbitrum.curve.fi/factory/19";
var _obj;
var TOKEN_BUY_LINKS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _config_types__WEBPACK_IMPORTED_MODULE_0__/* .ENativeAsset.VST */ .tx.VST, "https://arbitrum.curve.fi/factory/19/"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _config_types__WEBPACK_IMPORTED_MODULE_0__/* .FraxFarm.VST_FRAX_GAUGE */ .a0.VST_FRAX_GAUGE, "https://arbitrum.curve.fi/factory/19/deposit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _config_types__WEBPACK_IMPORTED_MODULE_0__/* .VestaFarm["VST-FRAX"] */ .xi["VST-FRAX"], "https://arbitrum.curve.fi/factory/19/"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _config_types__WEBPACK_IMPORTED_MODULE_0__/* .BoostedFarm["VST-USDC"] */ .bn["VST-USDC"], "https://z0r.de/1422"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _config_types__WEBPACK_IMPORTED_MODULE_0__/* .VestaFarm["VSTA-ETH"] */ .xi["VSTA-ETH"], "https://app.balancer.fi/#/arbitrum/pool/0xc61ff48f94d801c1ceface0289085197b5ec44f000020000000000000000004d"), _obj);


/***/ }),

/***/ 81576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TransactionButton; }
/* harmony export */ });
/* unused harmony export AFTER_TX_TIMEOUT_MS */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56748);
/* harmony import */ var _mui_icons_material_Check__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27036);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50594);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4615);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83321);
/* harmony import */ var _components_providers_TransactionProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51038);
/* harmony import */ var _components_providers_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22689);
/* harmony import */ var _components_shared_loading_LoadingText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33064);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16381);
/* harmony import */ var _buttonWithIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52787);














var AFTER_TX_TIMEOUT_MS = 3000;
var TransactionButton = function(_param) {
    var children = _param.children, onClick = _param.onClick, disabled = _param.disabled, validation = _param.validation, confirmContent = _param.confirmContent, sendingContent = _param.sendingContent, successContent = _param.successContent, txKey = _param.txKey, onCatch = _param.onCatch, onThen = _param.onThen, failedContent = _param.failedContent, _iconSize = _param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, _variant = _param.variant, variant = _variant === void 0 ? "primaryGradient" : _variant, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "children",
        "onClick",
        "disabled",
        "validation",
        "confirmContent",
        "sendingContent",
        "successContent",
        "txKey",
        "onCatch",
        "onThen",
        "failedContent",
        "iconSize",
        "variant"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), buttonDisabled = ref[0], setButtonDisabled = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), content = ref1[0], setButtonContent = ref1[1];
    var ref2 = (0,_components_providers_TransactionProvider__WEBPACK_IMPORTED_MODULE_2__/* .useTransactionProvider */ .wA)(), createTxInstance = ref2.createTxInstance, getTx = ref2.getTx;
    var currentTx = getTx(txKey);
    var state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!currentTx) return _components_providers_types__WEBPACK_IMPORTED_MODULE_3__/* .TxStatus.idle */ .b.idle;
        return currentTx.status;
    }, [
        currentTx
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setButtonDisabled(!!(validation === null || validation === void 0 ? void 0 : validation.error) || disabled || !!(currentTx === null || currentTx === void 0 ? void 0 : currentTx.isTransacting));
        switch(state){
            case "confirming":
                setButtonContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    direction: "row",
                    alignItems: "center",
                    children: [
                        confirmContent !== null && confirmContent !== void 0 ? confirmContent : "CONFIRM",
                        " \xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_loading_LoadingText__WEBPACK_IMPORTED_MODULE_4__/* .LoadingText */ .g, {
                            repeatSymbol: 3,
                            symbol: "."
                        }),
                        " "
                    ]
                }));
                break;
            case "sending":
                setButtonContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    direction: "row",
                    alignItems: "center",
                    children: [
                        sendingContent !== null && sendingContent !== void 0 ? sendingContent : "SENDING ",
                        "\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_loading_LoadingText__WEBPACK_IMPORTED_MODULE_4__/* .LoadingText */ .g, {
                            repeatSymbol: 3,
                            symbol: "."
                        })
                    ]
                }));
                break;
            case "success":
                setButtonContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    direction: "row",
                    alignItems: "center",
                    children: [
                        successContent !== null && successContent !== void 0 ? successContent : "SUCCESS ",
                        "\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Check__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            color: "success",
                            sx: {
                                height: iconSize,
                                width: iconSize
                            }
                        })
                    ]
                }));
                if (onThen) {
                    onThen();
                }
                break;
            case "error":
                setButtonContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    direction: "row",
                    alignItems: "center",
                    sx: {
                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_5__/* .statusRed[100] */ .hP[100]
                    },
                    children: [
                        failedContent !== null && failedContent !== void 0 ? failedContent : "FAILED ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            color: "error",
                            sx: {
                                height: iconSize,
                                width: iconSize
                            }
                        })
                    ]
                }));
                if (onCatch) {
                    onCatch();
                }
                break;
        }
    }, [
        state,
        validation,
        confirmContent,
        failedContent,
        disabled
    ]);
    var ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: state === "idle" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            placement: "top",
            title: (ref3 = validation === null || validation === void 0 ? void 0 : validation.helperText) !== null && ref3 !== void 0 ? ref3 : "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                width: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttonWithIcon__WEBPACK_IMPORTED_MODULE_6__/* .ButtonWithIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                    iconType: "asterisk",
                    disabled: buttonDisabled,
                    onClick: function(props) {
                        _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_15__/* .track */ .j("transaction", {
                            type: txKey,
                            status: "transaction-started"
                        });
                        if (onClick) {
                            onClick(props);
                        }
                    },
                    variant: variant
                }, props), {
                    children: children
                }))
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                width: "100%",
                height: 42
            }, props.sx),
            variant: variant,
            disabled: buttonDisabled,
            onClick: function() {
                if (state === _components_providers_types__WEBPACK_IMPORTED_MODULE_3__/* .TxStatus.success */ .b.success || state === _components_providers_types__WEBPACK_IMPORTED_MODULE_3__/* .TxStatus.error */ .b.error) {
                    createTxInstance({
                        key: txKey,
                        override: true
                    });
                }
            },
            children: content
        })
    });
};


/***/ }),

/***/ 39960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ AssetTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16381);
/* harmony import */ var _config_protocol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87055);
/* harmony import */ var _config_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87859);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66023);









var AssetTitle = function(param) {
    var asset = param.asset, active = param.active, hideTitle = param.hideTitle, sx = param.sx, reverse = param.reverse, subtitle = param.subtitle, containerSx = param.containerSx, secondary = param.secondary, gradientBg = param.gradientBg, customTitle = param.customTitle;
    var icons = null;
    if (Object.values(_config_types__WEBPACK_IMPORTED_MODULE_3__/* .ELPType */ .Yo).includes(asset)) {
        var ref = (0,_config_protocol__WEBPACK_IMPORTED_MODULE_2__/* .getAssetConfig */ .nf)(asset), tokenComposition = ref.tokenComposition, styles = ref.styles;
        if (tokenComposition && !styles.iconSrc) {
            icons = tokenComposition.map(function(singleAsset) {
                // need to add placeholder asset if missing
                // cfg now requires style
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .AssetIcon */ .Y, {
                    asset: singleAsset,
                    fullGradient: active && !gradientBg
                }, singleAsset);
            // else return <CircleWavyWarning size={16} color="#b3b4c1" weight="bold" />;
            });
        } else {
            icons = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .AssetIcon */ .Y, {
                asset: asset,
                fullGradient: active && !gradientBg
            }, asset);
        }
    } else {
        icons = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .AssetIcon */ .Y, {
            asset: asset,
            fullGradient: active && !gradientBg
        }, asset);
    }
    var ref1, ref2;
    var content = [
        !hideTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            sx: sx,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: secondary ? "h6" : "h5",
                    color: gradientBg ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[900] */ .w2[900] : _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[100] */ .w2[100],
                    children: customTitle ? customTitle : asset
                }),
                subtitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "label3",
                    color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[400] */ .w2[400],
                    children: subtitle
                }) : null
            ]
        }, "".concat(asset, "1")) : null,
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                mr: reverse ? "18px" : (ref1 = sx === null || sx === void 0 ? void 0 : sx.p) !== null && ref1 !== void 0 ? ref1 : 0,
                ml: reverse ? "24px" : (ref2 = sx === null || sx === void 0 ? void 0 : sx.p) !== null && ref2 !== void 0 ? ref2 : 0,
                display: "flex",
                alignItems: "center",
                gap: "8px"
            }, sx),
            children: icons
        }, "".concat(asset, "2")), 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        container: true,
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, containerSx), {
            background: gradientBg ? (0,_config_protocol__WEBPACK_IMPORTED_MODULE_2__/* .getAssetConfig */ .nf)(asset).styles.gradient : "#00000000",
            justifyContent: reverse ? "start" : "space-between",
            alignItems: "center"
        }),
        children: reverse ? content.reverse() : content
    });
};


/***/ }),

/***/ 89301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i0": function() { return /* binding */ LabelApr; },
  "$j": function() { return /* binding */ LabelAutomateGelato; },
  "rF": function() { return /* binding */ LabelBigEstimatedRewards; },
  "Dj": function() { return /* binding */ LabelBoostedAmount; },
  "bV": function() { return /* binding */ LabelBoostingAmount; },
  "HP": function() { return /* binding */ LabelCumulativeAmountUSD; },
  "h3": function() { return /* binding */ LabelDepositOrWithdraw; },
  "jB": function() { return /* binding */ LabelEarnBVsta; },
  "PM": function() { return /* binding */ LabelGetMoreLp; },
  "b2": function() { return /* binding */ LabelGovernanceStakingPenalty; },
  "H5": function() { return /* binding */ LabelLiquidationBonusStat; },
  "t9": function() { return /* binding */ LabelLiquidationRewards; },
  "DC": function() { return /* binding */ LabelLockPeriodDays; },
  "mm": function() { return /* binding */ LabelMarketPrice; },
  "Sz": function() { return /* binding */ LabelNewPoolShare; },
  "aF": function() { return /* binding */ LabelNewStakedAmount; },
  "TY": function() { return /* binding */ LabelOraclePrice; },
  "dB": function() { return /* binding */ LabelOverviewUserRewards; },
  "Os": function() { return /* binding */ LabelPoolRewards; },
  "Zl": function() { return /* binding */ LabelPoolShare; },
  "t4": function() { return /* binding */ LabelStakeUnixDate; },
  "Y$": function() { return /* binding */ LabelStakedAmount; },
  "xX": function() { return /* binding */ LabelTotalDebtRepay; },
  "Ct": function() { return /* binding */ LabelTotalValueLocked; },
  "z7": function() { return /* binding */ LabelUnlockDate; },
  "oh": function() { return /* binding */ LabelWithPrice; },
  "XF": function() { return /* binding */ LabelWithPriceChangedStat; },
  "zg": function() { return /* binding */ UserPoolRewards; }
});

// UNUSED EXPORTS: LabelDaysPassed, LabelEstimatedAPR, LabelLiquidationGains, LabelRewardApproximation, LabelRewards, LabelRewardsAccumulated, LabelTotalLiquidationBonus, TOTAL_DEBT_REPAY_TITLE

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box_Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/ArrowRight.esm.js
var ArrowRight_esm = __webpack_require__(27863);
// EXTERNAL MODULE: ./src/components/hooks/protocol/assets/useAssetPrices.ts + 4 modules
var useAssetPrices = __webpack_require__(10183);
// EXTERNAL MODULE: ./src/components/shared/link/index.tsx
var shared_link = __webpack_require__(67113);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/types.ts
var types = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/components/utils/utils.tsx
var utils = __webpack_require__(63189);
// EXTERNAL MODULE: ./src/config/links/index.ts
var links = __webpack_require__(84613);
// EXTERNAL MODULE: ./src/config/types.ts
var config_types = __webpack_require__(87859);
// EXTERNAL MODULE: ./src/v2/components/ui/label/index.tsx
var label = __webpack_require__(45306);
// EXTERNAL MODULE: ./src/v2/components/ui/buttons/transactionButton/index.tsx
var transactionButton = __webpack_require__(81576);
// EXTERNAL MODULE: ./src/v2/components/ui/icons/assets/index.tsx
var icons_assets = __webpack_require__(66023);
;// CONCATENATED MODULE: ./src/v2/components/ui/icons/assets/overlapped.tsx



var OverlappedAssetIcons = function(param) {
    var assets = param.assets, iconSize = param.iconSize, fullGradient = param.fullGradient, noBg = param.noBg, noBorder = param.noBorder;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        spacing: -1.2,
        children: assets.map(function(asset, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_assets/* AssetIcon */.Y, {
                noBg: noBg,
                noBorder: noBorder,
                zIndex: assets.length - (index + 1) * 2,
                asset: asset,
                fullGradient: fullGradient,
                size: iconSize,
                round: true
            }, asset);
        })
    });
};

// EXTERNAL MODULE: ./src/v2/components/ui/icons/vesta/index.tsx
var vesta = __webpack_require__(77435);
// EXTERNAL MODULE: ./src/v2/components/ui/switch/index.tsx
var ui_switch = __webpack_require__(44605);
;// CONCATENATED MODULE: ./src/v2/components/ui/label/stats/index.tsx




















var LabelPoolRewards = function(param) {
    var rewards = param.rewards, _variant = param.variant, variant = _variant === void 0 ? "body" : _variant, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
            variant: variant === "body" ? "horizontal" : "vertical",
            labelValueVariant: variant === "body" ? "label3" : "label2",
            labelTitle: "REWARDS",
            labelValue: rewards[0],
            labelValueUnit: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_assets/* AssetIcon */.Y, {
                size: 16,
                noBg: true,
                noBorder: true,
                asset: rewards[0]
            })
        }))
    });
// );
};
var LabelBigEstimatedRewards = function(param) {
    var estimatedRewards = param.estimatedRewards, rewardAsset = param.rewardAsset, lockPeriod = param.lockPeriod;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            flexDirection: "column",
            gap: "4px"
        },
        children: [
            lockPeriod !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                sx: {
                    color: colors/* primaryColors.600 */.w2[600]
                },
                variant: "label3",
                children: [
                    "YOUR ESTIMATED REWARDS FOR A",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        component: "span",
                        sx: {
                            color: colors/* primaryColors.100 */.w2[100]
                        },
                        children: [
                            lockPeriod,
                            " DAYS",
                            " "
                        ]
                    }),
                    "LOCK PERIOD"
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                sx: {
                    color: colors/* primaryColors.600 */.w2[600]
                },
                variant: "label3",
                children: [
                    "YOUR ESTIMATED REWARDS",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPoolRewards, {
                noClaimButton: true,
                rewards: [
                    {
                        amount: estimatedRewards,
                        asset: rewardAsset
                    }
                ],
                noLabel: true,
                disabled: true
            })
        ]
    });
};
var LabelWithPrice = function(param) {
    var asset = param.asset, halfVertical = param.halfVertical, assetAmount = param.assetAmount, _assetAmountColor = param.assetAmountColor, assetAmountColor = _assetAmountColor === void 0 ? colors/* primaryColors.100 */.w2[100] : _assetAmountColor, labelTitle = param.labelTitle, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        variant: "vertical"
    } : _labelProps, verticalOnMobile = param.verticalOnMobile;
    var ref = (0,useAssetPrices/* default */.ZP)(), all = ref.data.all;
    var assetPrice = asset ? all === null || all === void 0 ? void 0 : all[asset] : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        labelValueSx: {
            color: assetAmountColor
        }
    }, labelProps), {
        labelTitle: labelTitle,
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: assetAmount,
            displayType: types/* EDisplayType.number */.co.number,
            decimal: 2,
            unit: asset
        }),
        labelValueUnitSx: halfVertical ? {
            color: colors/* primaryColors.600 */.w2[600]
        } : undefined,
        labelValueUnit: halfVertical ? "(".concat((0,utils/* displayFormatUnits */.Hz)({
            value: assetPrice * assetAmount,
            displayType: types/* EDisplayType.USD */.co.USD
        }), ")") : undefined,
        verticalOnMobile: verticalOnMobile,
        labelValueAnnotation: !halfVertical && !isNaN(assetAmount) && asset ? labelProps.variant === "vertical" ? (0,utils/* displayFormatUnits */.Hz)({
            value: assetPrice * assetAmount,
            displayType: types/* EDisplayType.USD */.co.USD
        }) : "(".concat((0,utils/* displayFormatUnits */.Hz)({
            value: assetPrice * assetAmount,
            displayType: types/* EDisplayType.USD */.co.USD
        }), ")") : undefined
    }));
};
var LabelApr = function(param) {
    var _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, apr = param.apr, customTitle = param.customTitle, rewards = param.rewards, _variant = param.variant, variant = _variant === void 0 ? "body" : _variant, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        variant: variant === "body" ? "horizontal" : "vertical",
        align: variant === "body" ? "start" : "end"
    } : _labelProps, _hasTooltip = param.hasTooltip, hasTooltip = _hasTooltip === void 0 ? true : _hasTooltip;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread/* default */.Z)({
        toolTip: hasTooltip ? {
            content: "APR For current pool.",
            placement: rewards ? "title" : "value"
        } : undefined,
        labelTitle: customTitle !== null && customTitle !== void 0 ? customTitle : rewards ? "".concat(rewards === null || rewards === void 0 ? void 0 : rewards[0], " APR") : "APR",
        labelValue: apr === 0 ? "-" : (0,utils/* displayFormatUnits */.Hz)({
            value: apr,
            displayType: types/* EDisplayType.Percent */.co.Percent
        }),
        labelValueUnit: rewards ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlappedAssetIcons, {
            noBg: true,
            noBorder: true,
            iconSize: iconSize,
            assets: rewards
        }) : undefined
    }, labelProps));
};
var LabelPoolShare = function(param) {
    var poolShare = param.poolShare, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        toolTip: {
            content: "Your current pool share",
            placement: "value"
        }
    } : _labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "POOL SHARE:",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: poolShare,
            displayType: types/* EDisplayType.Percent */.co.Percent
        })
    }));
};
var LabelNewPoolShare = function(param) {
    var poolShare = param.poolShare, _isStake = param.isStake, isStake = _isStake === void 0 ? true : _isStake, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "NEW POOL SHARE:",
        labelValueSx: {
            color: isStake ? colors/* statusGreen.100 */.hY[100] : colors/* statusRed.100 */.hP[100]
        },
        labelValueVariant: "label3",
        labelValue: poolShare >= 0.999 ? "~ 100.00 %" : (0,utils/* displayFormatUnits */.Hz)({
            value: poolShare,
            displayType: types/* EDisplayType.Percent */.co.Percent
        }),
        toolTip: {
            content: "Your new pool share after your action",
            placement: "title"
        }
    }));
};
var LabelStakedAmount = function(param) {
    var asset = param.asset, stakedAmount = param.stakedAmount, _variant = param.variant, variant = _variant === void 0 ? "header" : _variant, customTitle = param.customTitle, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        align: "start",
        variant: variant === "header" ? "vertical" : "horizontal",
        labelValueVariant: variant === "header" ? "label2" : "label3",
        toolTip: {
            content: "Your staked tokens",
            placement: variant === "header" ? "title" : "value"
        }
    } : _labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
        labelProps: labelProps,
        labelTitle: customTitle ? customTitle : "STAKED AMOUNT",
        assetAmount: stakedAmount,
        asset: asset
    });
};
var LabelNewStakedAmount = function(param) {
    var asset = param.asset, stakedAmount = param.stakedAmount, stakedAmountUsd = param.stakedAmountUsd, _isStake = param.isStake, isStake = _isStake === void 0 ? true : _isStake, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        align: "end"
    } : _labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "NEW STAKED AMOUNT:",
        labelValueSx: {
            color: isStake ? colors/* statusGreen.100 */.hY[100] : colors/* statusRed.100 */.hP[100]
        },
        labelValueVariant: "label3",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: stakedAmount,
            displayType: types/* EDisplayType.Token */.co.Token,
            decimal: 5,
            unit: asset
        }),
        labelValueAnnotation: "(".concat((0,utils/* displayFormatUnits */.Hz)({
            value: stakedAmountUsd,
            displayType: types/* EDisplayType.USD */.co.USD
        }), ")")
    }));
};
var LabelTotalValueLocked = function(param) {
    var totalValueLocked = param.totalValueLocked, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        align: "end"
    } : _labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "TVL:",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: totalValueLocked,
            displayType: types/* EDisplayType.USD */.co.USD
        }),
        toolTip: {
            content: "Total Value Locked in current pool.",
            placement: "value"
        }
    }));
};
var LabelLiquidationBonusStat = function(param) {
    var liquidationBonus = param.liquidationBonus, labelProps = param.labelProps, asset = param.asset;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "LIQUIDATION BONUS:",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: liquidationBonus,
            displayType: types/* EDisplayType.Percent */.co.Percent
        }),
        toolTip: {
            content: "The bonus Vesta provides on all current vault liquidation rewards.",
            placement: "title"
        },
        skeletonProps: (labelProps === null || labelProps === void 0 ? void 0 : labelProps.labelValueVariant) === "label1" ? {
            height: 32
        } : undefined,
        labelValueUnit: asset ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_assets/* AssetIcon */.Y, {
            size: (labelProps === null || labelProps === void 0 ? void 0 : labelProps.labelValueVariant) === "label1" ? 20 : 14,
            noBg: true,
            noBorder: true,
            asset: asset
        }) : undefined
    }));
};
var LabelTotalLiquidationBonus = function(param) {
    var asset = param.asset, totalLiquidationBonus = param.totalLiquidationBonus, totalLiquidationBonusUsd = param.totalLiquidationBonusUsd, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        align: "end"
    } : _labelProps;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: "TOTAL BONUSES:",
        labelValueVariant: "label3",
        labelValue: displayFormatUnits({
            value: totalLiquidationBonus,
            displayType: EDisplayType.number,
            decimal: 5,
            unit: asset
        }),
        labelValueAnnotation: "(".concat(displayFormatUnits({
            value: totalLiquidationBonusUsd,
            displayType: EDisplayType.USD
        }), ")")
    }));
};
var LabelLiquidationGains = function(param) {
    var asset = param.asset, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        align: "end"
    } : _labelProps;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: "LIQ. GAINS",
        labelValueVariant: "label3",
        labelValue: "$".concat(asset),
        labelValueUnit: /*#__PURE__*/ _jsx(AssetIcon, {
            size: 14,
            noBg: true,
            noBorder: true,
            asset: asset
        }),
        toolTip: {
            content: "The asset you receive when liquidations occur.",
            placement: "title"
        }
    }));
};
var LabelStakeUnixDate = function(param) {
    var stakeDate = param.stakeDate, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "STAKE DATE:",
        labelValue: moment_default()(stakeDate).format("MMMM Do YYYY"),
        toolTip: {
            content: "lorem ipsum",
            placement: "value"
        }
    }));
};
var LabelLockPeriodDays = function(param) {
    var lockPeriod = param.lockPeriod, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        labelValueSx: {
            color: colors/* primaryColors.300 */.w2[300]
        }
    } : _labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "LOCK PERIOD:",
        labelValue: "".concat(lockPeriod, " DAYS"),
        toolTip: {
            content: "LOREM IPSUM CMON",
            placement: "value"
        }
    }));
};
var LabelUnlockDate = function(param) {
    var withdrawDate = param.withdrawDate, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "UNLOCK DATE:",
        labelValue: moment_default()(withdrawDate).format("MMMM Do YYYY"),
        toolTip: {
            content: "LOREM IPSUM YOOOO",
            placement: "value"
        }
    }));
};
var LabelDaysPassed = function(param) {
    var daysPassed = param.daysPassed, labelProps = param.labelProps;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: "DAYS PASSED:",
        labelValue: "".concat(daysPassed, " DAYS")
    }));
};
var UserPoolRewards = function(param) {
    var rewards = param.rewards, noLabel = param.noLabel, horizontal = param.horizontal, disabled = param.disabled, onClaim = param.onClaim, total = param.total, txKey = param.txKey, title = param.title, noClaimButton = param.noClaimButton, labelProps = param.labelProps, width = param.width;
    var totalClaimable = rewards.reduce(function(prev, cur) {
        return prev + cur.amount;
    }, 0);
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        justifyContent: "space-between",
        direction: "row",
        alignItems: "center",
        width: width,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread/* default */.Z)({
                labelTitle: !noLabel ? title ? title : total ? "TOTAL PENDING REWARDS: " : "REWARDS: " : "",
                labelValue: rewards.map(function(reward, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                        children: reward.amount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: {
                                        background: colors/* vestaGradient */.pK,
                                        backgroundClip: "text",
                                        WebkitTextFillColor: "transparent"
                                    },
                                    typography: (ref = labelProps === null || labelProps === void 0 ? void 0 : labelProps.labelValueVariant) !== null && ref !== void 0 ? ref : "label2",
                                    component: "span",
                                    children: "".concat(reward.asset ? "" : "$").concat((0,utils/* displayFormatUnits */.Hz)({
                                        value: reward.amount,
                                        displayType: types/* EDisplayType.Token */.co.Token
                                    }), " ")
                                }, index),
                                reward.asset ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    component: "span",
                                    color: colors/* primaryColors.400 */.w2[400],
                                    typography: (ref1 = labelProps === null || labelProps === void 0 ? void 0 : labelProps.labelValueVariant) !== null && ref1 !== void 0 ? ref1 : "label2",
                                    children: reward.asset
                                }) : ""
                            ]
                        }) : index < 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            component: "span",
                            typography: (ref2 = labelProps === null || labelProps === void 0 ? void 0 : labelProps.labelValueVariant) !== null && ref2 !== void 0 ? ref2 : "label2",
                            children: "N/A"
                        }, index) : ""
                    }, index);
                }),
                labelValueSx: {
                    color: colors/* secondaryColors.200 */.St[200]
                },
                variant: horizontal ? "horizontal" : "vertical"
            }, labelProps)),
            !noClaimButton && txKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(transactionButton/* TransactionButton */.H, {
                iconType: "coin",
                sx: {
                    minWidth: 42,
                    width: 42,
                    maxWidth: 42,
                    p: 1,
                    "&:disabled": {
                        background: "initial"
                    }
                },
                variant: "primary",
                txKey: txKey,
                confirmContent: " ",
                sendingContent: " ",
                successContent: " ",
                failedContent: " ",
                onClick: onClaim,
                disabled: rewards.length <= 0 || totalClaimable <= 0 || disabled
            }) : null
        ]
    });
};
var LabelOverviewUserRewards = function(param) {
    var asset = param.asset, rewardAmount = param.rewardAmount, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "PENDING REWARDS:",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: rewardAmount,
            displayType: types/* EDisplayType.number */.co.number,
            decimal: 5,
            unit: asset
        }),
        labelValueUnit: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_assets/* AssetIcon */.Y, {
            noBg: true,
            noBorder: true,
            size: 14,
            asset: asset
        })
    }));
};
var LabelRewardsAccumulated = function(param) {
    var asset = param.asset, rewardAmount = param.rewardAmount, rewardAmountUsd = param.rewardAmountUsd, labelProps = param.labelProps;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: "PENDING REWARDS:",
        labelValue: displayFormatUnits({
            value: rewardAmount,
            displayType: EDisplayType.number,
            decimal: 5,
            unit: asset
        }),
        labelValueAnnotation: "(".concat(displayFormatUnits({
            value: rewardAmountUsd,
            displayType: EDisplayType.USD
        }), ")")
    }));
};
var LabelMarketPrice = function(param) {
    var asset = param.asset, labelProps = param.labelProps;
    var ref = (0,useAssetPrices/* default */.ZP)(), priceData = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "MARKET PRICE:",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: priceData.market[asset === config_types/* EVestaAsset.ETH */.e2.ETH ? "WETH" : asset],
            displayType: types/* EDisplayType.USD */.co.USD
        })
    }));
};
var LabelOraclePrice = function(param) {
    var asset = param.asset, labelProps = param.labelProps;
    var ref = (0,useAssetPrices/* default */.ZP)(), priceData = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: "ORACLE PRICE:",
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: priceData.oracle[asset],
            displayType: types/* EDisplayType.USD */.co.USD
        })
    }));
};
var LabelCumulativeAmountUSD = function(param) {
    var value = param.value, tooltipContent = param.tooltipContent, labelTitle = param.labelTitle, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
        variant: "vertical",
        labelTitle: labelTitle,
        labelValueVariant: "label2",
        isLoading: isLoading,
        labelValue: (0,utils/* displayFormatUnits */.Hz)({
            value: value,
            displayType: types/* EDisplayType.USD */.co.USD
        }),
        toolTip: {
            content: tooltipContent,
            placement: "title"
        }
    });
};
var LabelEstimatedAPR = function(param) {
    var _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        variant: "vertical",
        align: "right"
    } : _labelProps, approxApr = param.approxApr;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: "EST. APR:",
        labelValue: "~".concat(displayFormatUnits({
            value: approxApr,
            displayType: EDisplayType.Percent
        })),
        labelValueVariant: "label2"
    }));
};
var LabelRewards = function(param) {
    var labelProps = param.labelProps, rewards = param.rewards, asset = param.asset, _title = param.title, title = _title === void 0 ? "REWARDS" : _title;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: title,
        labelValue: /*#__PURE__*/ _jsxs(Typography, {
            variant: "label2",
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    component: "span",
                    sx: {
                        color: secondaryColors[200]
                    },
                    children: "".concat(displayFormatUnits({
                        value: rewards,
                        decimal: 5,
                        displayType: EDisplayType.number
                    }), " ")
                }),
                asset
            ]
        }),
        toolTip: {
            placement: "title",
            content: "Accumulated ".concat(asset, " rewards")
        }
    }));
};
var LabelLiquidationRewards = function(param) {
    var labelProps = param.labelProps, liquidationGains = param.liquidationGains, asset = param.asset, _title = param.title, title = _title === void 0 ? "LIQUIDATION GAINS" : _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, labelProps), {
        labelTitle: title,
        skeletonProps: {
            height: 32
        },
        labelValue: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            variant: "label2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    component: "span",
                    sx: {
                        color: colors/* secondaryColors.200 */.St[200]
                    },
                    children: "".concat((0,utils/* displayFormatUnits */.Hz)({
                        value: liquidationGains,
                        decimal: 5,
                        displayType: types/* EDisplayType.number */.co.number
                    }), " ")
                }),
                asset
            ]
        }),
        toolTip: {
            placement: "title",
            content: "Accumulated rewards from liquidation"
        }
    }));
};
var LabelRewardApproximation = function(param) {
    var labelProps = param.labelProps, approximation = param.approximation, asset = param.asset, _title = param.title, title = _title === void 0 ? "FRIENDLY REWARDS APPROXIMATION" : _title;
    return /*#__PURE__*/ _jsx(GenericInfoLabel, _object_spread_props(_object_spread({}, labelProps), {
        labelTitle: title,
        variant: "vertical",
        labelValue: /*#__PURE__*/ _jsxs(Typography, {
            variant: "label2",
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    component: "span",
                    sx: {
                        color: secondaryColors[200]
                    },
                    children: "".concat(displayFormatUnits({
                        value: approximation,
                        decimal: 5,
                        displayType: EDisplayType.number
                    }), " ")
                }),
                asset
            ]
        }),
        toolTip: {
            placement: "title",
            content: "Approximated ".concat(asset, " rewards")
        }
    }));
};
var TOTAL_DEBT_REPAY_TITLE = "TOTAL DEBT TO REPAY";
var LabelTotalDebtRepay = function(param) {
    var assetAmount = param.assetAmount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
        labelProps: {
            variant: "vertical",
            labelValueVariant: "label1"
        },
        asset: config_types/* ENativeAsset.VST */.tx.VST,
        labelTitle: TOTAL_DEBT_REPAY_TITLE,
        assetAmount: assetAmount
    });
};
var LabelGovernanceStakingPenalty = function(param) {
    var penalty = param.penalty, labelProps = param.labelProps, _percent = param.percent, percent = _percent === void 0 ? true : _percent, _hasTooltip = param.hasTooltip, hasTooltip = _hasTooltip === void 0 ? true : _hasTooltip, _labelTitle = param.labelTitle, labelTitle = _labelTitle === void 0 ? "BVSTA PENALTY:" : _labelTitle;
    var hasPenalty = percent ? penalty < 0 : penalty > 0;
    if (percent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread/* default */.Z)({
            labelTitle: labelTitle,
            labelValue: (0,utils/* displayFormatUnits */.Hz)({
                value: penalty,
                displayType: types/* EDisplayType.Percent */.co.Percent
            }),
            labelValueUnit: /*#__PURE__*/ (0,jsx_runtime.jsx)(vesta/* VestaIcon */.QA, {
                size: 24,
                noBg: true,
                noBorder: true,
                icon: hasPenalty ? vesta/* VestaIcons.PENALTY_WARNING */.wb.PENALTY_WARNING : vesta/* VestaIcons.PENALTY_OKAY */.wb.PENALTY_OKAY
            }),
            toolTip: hasTooltip ? {
                content: "Lorem Ipsum",
                placement: "title"
            } : undefined
        }, labelProps));
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
            labelTitle: labelTitle,
            labelValue: "".concat((0,utils/* displayFormatUnits */.Hz)({
                value: penalty,
                displayType: types/* EDisplayType.Token */.co.Token
            }), "%"),
            labelValueUnit: /*#__PURE__*/ (0,jsx_runtime.jsx)(vesta/* VestaIcon */.QA, {
                size: 24,
                noBg: true,
                noBorder: true,
                icon: hasPenalty ? vesta/* VestaIcons.PENALTY_WARNING */.wb.PENALTY_WARNING : vesta/* VestaIcons.PENALTY_OKAY */.wb.PENALTY_OKAY
            }),
            toolTip: {
                content: "Lorem Ipsum",
                placement: "title"
            }
        });
    }
};
var LabelWithPriceChangedStat = function(param) {
    var title = param.title, asset = param.asset, _labelValueVariant = param.labelValueVariant, labelValueVariant = _labelValueVariant === void 0 ? "label3" : _labelValueVariant, currentValue = param.currentValue, finalValue = param.finalValue, invert = param.invert, tooltip = param.tooltip;
    var isIncreasing = finalValue > currentValue;
    var isEqual = finalValue === currentValue;
    var COLORS = [
        colors/* statusGreen.100 */.hY[100],
        colors/* primaryColors.100 */.w2[100],
        colors/* statusRed.100 */.hP[100]
    ];
    var FINAL_VALUE_TEXT_COLOR = COLORS[!isEqual ? isIncreasing && !invert ? 0 : 2 : 1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
                    labelProps: {
                        variant: "vertical",
                        labelValueVariant: labelValueVariant,
                        toolTip: tooltip
                    },
                    asset: asset,
                    labelTitle: title,
                    assetAmount: currentValue
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                item: true,
                xs: 2,
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    width: 16,
                    height: 16,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight_esm/* default */.Z, {
                        size: 16,
                        color: "#b3b4c1",
                        weight: "bold"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
                    labelTitle: "NEW STAKE",
                    labelProps: {
                        variant: "vertical",
                        labelValueVariant: labelValueVariant,
                        align: "right",
                        labelValueSx: {
                            transition: "color 0.15s ease-in-out",
                            color: FINAL_VALUE_TEXT_COLOR
                        }
                    },
                    asset: asset,
                    assetAmount: finalValue,
                    assetAmountColor: FINAL_VALUE_TEXT_COLOR
                })
            })
        ]
    });
};
var LabelAutomateGelato = function(param) {
    var checked = param.checked, handleChange = param.handleChange, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        sx: {
            alignItems: "center",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread/* default */.Z)({
                labelTitle: "MARKET PRICE:",
                labelValue: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* default */.ZP, {
                    href: "https://z0r.de/1422",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "label3",
                        children: [
                            "AUTOMATE BOOSTING USING",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                sx: {
                                    color: colors/* secondaryColors.200 */.St[200]
                                },
                                children: "GELATO"
                            })
                        ]
                    })
                }),
                sx: {
                    width: "fit-content"
                }
            }, labelProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_switch/* LabeledSwitch */.t, {
                defaultChecked: true,
                checked: checked,
                onChange: handleChange,
                onColor: colors/* secondaryColors.200 */.St[200],
                offColor: colors/* primaryColors.700 */.w2[700],
                size: "small"
            })
        ]
    });
};
var LabelBoostingAmount = function(param) {
    var boostingAmount = param.boostingAmount, _isBoost = param.isBoost, isBoost = _isBoost === void 0 ? true : _isBoost, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
        asset: config_types/* ENativeAsset.bVSTA */.tx.bVSTA,
        assetAmount: boostingAmount,
        labelTitle: isBoost ? "BOOSTING:" : "UNBOOSTING:",
        labelProps: (0,src_object_spread/* default */.Z)({
            variant: "vertical",
            labelValueVariant: "label2",
            toolTip: {
                content: "Lorem ipsum is everywhere.",
                placement: "title"
            }
        }, labelProps)
    });
};
var LabelGetMoreLp = function(param) {
    var farm = param.farm, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread/* default */.Z)({
        sx: {
            width: "fit-content"
        },
        toolTip: {
            content: "Lorem ipsum",
            placement: "value"
        },
        labelValue: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* default */.ZP, {
            href: links/* TOKEN_BUY_LINKS */.B[farm],
            target: "_blank",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "label3",
                sx: {
                    color: colors/* secondaryColors.200 */.St[200]
                },
                children: "GET MORE LP"
            })
        })
    }, labelProps));
};
var LabelEarnBVsta = function(param) {
    var labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, (0,src_object_spread/* default */.Z)({
        sx: {
            width: "fit-content"
        },
        toolTip: {
            content: "Lorem ipsum",
            placement: "value"
        },
        labelValue: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* default */.ZP, {
            href: "/coreModule",
            target: "_blank",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "label3",
                sx: {
                    color: colors/* secondaryColors.200 */.St[200]
                },
                children: "EARN ".concat(config_types/* ENativeAsset.bVSTA */.tx.bVSTA)
            })
        })
    }, labelProps));
};
var LabelDepositOrWithdraw = function(param) {
    var asset = param.asset, assetAmount = param.assetAmount, _isDeposit = param.isDeposit, isDeposit = _isDeposit === void 0 ? true : _isDeposit, labelProps = param.labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
        asset: asset,
        assetAmount: assetAmount,
        labelTitle: isDeposit ? "DEPOSITING:" : "WITHDRAWING:",
        labelProps: (0,src_object_spread/* default */.Z)({
            variant: "vertical",
            labelValueVariant: "label2",
            toolTip: {
                content: "Lorem ipsum is everywhere.",
                placement: "title"
            }
        }, labelProps)
    });
};
var LabelBoostedAmount = function(param) {
    var boostedAmount = param.boostedAmount, variant = param.variant, customTitle = param.customTitle, _labelProps = param.labelProps, labelProps = _labelProps === void 0 ? {
        align: "start",
        variant: variant === "header" ? "vertical" : "horizontal",
        labelValueVariant: variant === "header" ? "label2" : "label3",
        toolTip: {
            content: "Your boosted tokens",
            placement: variant === "header" ? "title" : "value"
        }
    } : _labelProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithPrice, {
        labelProps: labelProps,
        labelTitle: customTitle ? customTitle : "BOOSTED AMOUNT",
        assetAmount: boostedAmount,
        asset: config_types/* ENativeAsset.bVSTA */.tx.bVSTA
    });
};


/***/ }),

/***/ 44605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LabeledSwitch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45843);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16381);




var LabeledSwitch = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        focusVisibleClassName: ".Mui-focusVisible",
        disableRipple: true
    }, props));
}, {
    shouldForwardProp: function(prop) {
        return prop !== "onText" && prop !== "offText" && prop !== "onColor" && prop !== "offColor" && prop !== "textOnColor" && prop !== "textOffColor";
    }
})(function(param) {
    var theme = param.theme, checked = param.checked, _onText = param.onText, onText = _onText === void 0 ? " " : _onText, _offText = param.offText, offText = _offText === void 0 ? " " : _offText, _onColor = param.onColor, onColor = _onColor === void 0 ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .grayColors[900] */ .ab[900] : _onColor, _offColor = param.offColor, offColor = _offColor === void 0 ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .grayColors[900] */ .ab[900] : _offColor, _textOnColor = param.textOnColor, textOnColor = _textOnColor === void 0 ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[100] */ .w2[100] : _textOnColor, _textOffColor = param.textOffColor, textOffColor = _textOffColor === void 0 ? _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[900] */ .w2[900] : _textOffColor, _size = param.size, size = _size === void 0 ? "medium" : _size;
    return {
        width: size === "medium" ? 60 : 54,
        height: size === "medium" ? 30 : 24,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            transitionDuration: "200ms",
            color: offColor,
            background: offColor,
            "&.Mui-checked": {
                transform: "translateX(29.5px)",
                color: onColor,
                background: onColor,
                "& .MuiSwitch-thumb:before": {
                    content: '"'.concat(onText, '"')
                },
                "& + .MuiSwitch-track": {
                    backgroundColor: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .grayColors[900] */ .ab[900],
                    opacity: 1
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5
                }
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d"
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: theme.palette.mode === "light" ? 0.7 : 0.3
            }
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            border: "1px solid rgba(255, 255, 255, 0.15)",
            background: checked && onColor ? onColor : _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .black["85%"] */ .Sn["85%"],
            width: size === "medium" ? 30 : 24,
            height: size === "medium" ? 30 : 24,
            "&:before, &:after": {
                content: '""',
                fontSize: 11,
                position: "absolute",
                transform: "translateY(-50%)",
                width: 18,
                height: 16,
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[100] */ .w2[100]
            },
            "&:before": {
                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .primaryColors[100] */ .w2[100],
                content: '"'.concat(offText, '"'),
                top: 8,
                left: 8
            }
        },
        "& .MuiSwitch-track": {
            borderRadius: 32 / 2,
            border: "1px solid rgba(255, 255, 255, 0.15)",
            backgroundColor: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_1__/* .grayColors[900] */ .ab[900],
            opacity: 1,
            transition: theme.transitions.create([
                "background-color"
            ], {
                duration: 500
            }),
            "&:before, &:after": {
                content: '""',
                fontSize: 11,
                position: "absolute",
                transform: "translateY(-50%)",
                width: 18,
                height: 16
            },
            "&:before": {
                color: textOffColor,
                content: '"'.concat(offText, '"'),
                top: 8,
                left: 7
            },
            "&:after": {
                color: textOnColor,
                content: '"'.concat(onText, '"'),
                top: 8,
                right: 4
            }
        }
    };
});


/***/ })

}]);